module.exports = require("@splunk/dashboard-visualizations/Area");